module.exports = __webpack_public_path__ + "img/wild_comming.992e53a8.png";